export default function Videos() {
  return (
    <div style={{padding:"20px"}}>
      <h1>Temple Videos</h1>
      <p>Video gallery will come here</p>
    </div>
  );
}